export default __webpack_public_path__ + "static/media/midasi_entry_en_sp.e93c3b52.png";